var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9542 23.5808C37.3486 18.1864 37.3486 9.44025 31.9542 4.04581C26.5598 -1.3486 17.8136 -1.3486 12.4192 4.04581C8.83732 7.62769 7.6338 12.6873 8.80864 17.2622C8.99812 18 8.82984 18.798 8.29116 19.3368L0.866984 26.7608C0.231164 27.3968 -0.0811766 28.287 0.0181234 29.1808L0.482264 33.358C0.531744 33.8034 0.731324 34.2186 1.04816 34.5354L1.46458 34.9518C1.78144 35.2686 2.19668 35.4682 2.64202 35.5178L6.8192 35.9818C7.7129 36.0812 8.60328 35.7688 9.23912 35.133L10.6592 33.713L12.7805 31.5916L16.6638 27.7082C17.2026 27.1696 18 27.0018 18.7378 27.1914C23.3126 28.3662 28.3722 27.1626 31.9542 23.5808Z",
    fill: "#6D00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8284 11.1717C23.2664 9.6096 20.7336 9.6096 19.1716 11.1717C17.6095 12.7338 17.6095 15.2665 19.1716 16.8285C20.7336 18.3907 23.2664 18.3907 24.8284 16.8285C26.3906 15.2665 26.3906 12.7338 24.8284 11.1717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16589 30.2586L10.6582 33.7128L12.7795 31.5914L9.27551 28.1258C8.68651 27.5432 7.73677 27.5484 7.15421 28.1374C6.57167 28.7264 6.57689 29.6762 7.16589 30.2586Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.d7269315a288ce7f879c8f935b233057.svg";
export { ForwardRef as ReactComponent };